/** Dealer directory UI copy — leaf module (no imports). */

export function getDealerDirectoryLinks(t) {
  return {
    label: t("automotive.dealerDirectory.label"),
    viewDealers: t("automotive.dealerDirectory.viewDealers"),
    viewAllDealers: t("automotive.dealerDirectory.viewAllDealers"),
    homepageSupporting: t("automotive.dealerDirectory.homepageSupporting"),
    searchByDealerPrompt: t("automotive.dealerDirectory.searchByDealerPrompt"),
    searchByDealerLink: t("automotive.dealerDirectory.searchByDealerLink"),
    exploreOtherDealers: t("automotive.dealerDirectory.exploreOtherDealers"),
  };
}

export function getDealerDirectoryPageCopy(t) {
  return {
    eyebrow: t("automotive.dealerDirectory.page.eyebrow"),
    title: t("automotive.dealerDirectory.page.title"),
    intro: t("automotive.dealerDirectory.page.intro"),
    trustNote: t("automotive.dealerDirectory.page.trustNote"),
    searchCta: t("automotive.dealerDirectory.page.searchCta"),
    exploreDealersCta: t("automotive.dealerDirectory.page.exploreDealersCta"),
    profileCta: t("automotive.dealerDirectory.page.profileCta"),
    loading: t("automotive.dealerDirectory.page.loading"),
    emptyTitle: t("automotive.dealerDirectory.page.emptyTitle"),
    emptyBody: t("automotive.dealerDirectory.page.emptyBody"),
    errorTitle: t("automotive.dealerDirectory.page.errorTitle"),
    errorBody: t("automotive.dealerDirectory.page.errorBody"),
    retry: t("automotive.dealerDirectory.page.retry"),
    resultMany: (count) => t("automotive.dealerDirectory.page.resultMany", { count }),
    resultOne: t("automotive.dealerDirectory.page.resultOne"),
    resultGeneric: t("automotive.dealerDirectory.page.resultGeneric"),
    resultFilteredMany: (count) => t("automotive.dealerDirectory.page.resultFilteredMany", { count }),
    resultFilteredOne: t("automotive.dealerDirectory.page.resultFilteredOne"),
    filteredEmptyTitle: t("automotive.dealerDirectory.page.filteredEmptyTitle"),
    filteredEmptyBody: t("automotive.dealerDirectory.page.filteredEmptyBody"),
    clearFilters: t("automotive.dealerDirectory.page.clearFilters"),
    statDealers: (count) => t("automotive.dealerDirectory.page.statDealers", { count }),
    statVerified: (count) => t("automotive.dealerDirectory.page.statVerified", { count }),
    statInventory: (count) => t("automotive.dealerDirectory.page.statInventory", { count }),
    contentHeading: t("automotive.dealerDirectory.page.contentHeading"),
    contentSubheading: t("automotive.dealerDirectory.page.contentSubheading"),
    trustBlockHeading: t("automotive.dealerDirectory.page.trustBlockHeading"),
    trustBlockChecklistCta: t("automotive.dealerDirectory.page.trustBlockChecklistCta"),
    statsAria: t("automotive.dealerDirectory.page.statsAria"),
    mapTitle: t("automotive.dealerDirectory.page.mapTitle"),
    viewModeLabel: t("automotive.dealerDirectory.page.viewModeLabel"),
    viewModeList: t("automotive.dealerDirectory.page.viewModeList"),
    viewModeSplit: t("automotive.dealerDirectory.page.viewModeSplit"),
    viewModeMap: t("automotive.dealerDirectory.page.viewModeMap"),
    mapScopeHint: t("automotive.dealerDirectory.page.mapScopeHint"),
    mapAria: t("automotive.dealerDirectory.page.mapAria"),
    mapUnavailable: t("automotive.dealerDirectory.page.mapUnavailable"),
    mapNoLocations: t("automotive.dealerDirectory.page.mapNoLocations"),
    mapUnmappedHint: (count) => t("automotive.dealerDirectory.page.mapUnmappedHint", { count }),
    popupViewProfile: t("automotive.dealerDirectory.page.popupViewProfile"),
    popupFallbackName: t("automotive.dealerDirectory.page.popupFallbackName"),
    popupInventoryMany: (count) => t("automotive.dealerDirectory.page.popupInventoryMany", { count }),
    heroAria: t("automotive.dealerDirectory.page.heroAria"),
    trustAlertDismissAria: t("automotive.dealerDirectory.page.trustAlertDismissAria"),
  };
}

export function getDealerDirectoryPartnershipAdCopy(t) {
  return {
    eyebrow: t("automotive.dealerDirectory.page.partnershipEyebrow"),
    title: t("automotive.dealerDirectory.page.partnershipTitle"),
    body: t("automotive.dealerDirectory.page.partnershipBody"),
    bullets: [
      t("automotive.dealerDirectory.page.partnershipBulletLeads"),
      t("automotive.dealerDirectory.page.partnershipBulletProfile"),
      t("automotive.dealerDirectory.page.partnershipBulletFounding"),
    ],
    cta: t("automotive.dealerDirectory.page.partnershipCta"),
    secondaryCta: t("automotive.dealerDirectory.page.partnershipSecondaryCta"),
  };
}

export function getDealerDirectoryFilterCopy(t) {
  return {
    heading: t("automotive.dealerDirectory.filters.heading"),
    search: t("automotive.dealerDirectory.filters.search"),
    searchPlaceholder: t("automotive.dealerDirectory.filters.searchPlaceholder"),
    city: t("automotive.dealerDirectory.filters.city"),
    cityAll: t("automotive.dealerDirectory.filters.cityAll"),
    neighborhood: t("automotive.dealerDirectory.filters.neighborhood"),
    neighborhoodAll: t("automotive.dealerDirectory.filters.neighborhoodAll"),
    verifiedOnly: t("automotive.dealerDirectory.filters.verifiedOnly"),
    hasInventory: t("automotive.dealerDirectory.filters.hasInventory"),
    contactAvailable: t("automotive.dealerDirectory.filters.contactAvailable"),
    sort: t("automotive.dealerDirectory.filters.sort"),
    clearFilters: t("automotive.dealerDirectory.filters.clearFilters"),
    appliedFilters: t("automotive.dealerDirectory.filters.appliedFilters"),
    removeFilterAria: t("automotive.dealerDirectory.filters.removeFilterAria"),
    filter: t("automotive.dealerDirectory.filters.filter"),
    applyFilters: t("automotive.dealerDirectory.filters.clearFilters"),
    clear: t("automotive.dealerDirectory.filters.clearFilters"),
    showResults: t("automotive.dealerDirectory.page.resultGeneric"),
    sortOptions: [
      { value: "recommended", label: t("automotive.dealerDirectory.filters.sortRecommended") },
      { value: "verified_first", label: t("automotive.dealerDirectory.filters.sortVerifiedFirst") },
      { value: "most_inventory", label: t("automotive.dealerDirectory.filters.sortMostInventory") },
      { value: "recently_updated", label: t("automotive.dealerDirectory.filters.sortRecentlyUpdated") },
      { value: "alphabetical", label: t("automotive.dealerDirectory.filters.sortAlphabetical") },
    ],
  };
}

export function getDealerDirectoryFeaturedCopy(t) {
  return {
    heading: t("automotive.dealerDirectory.featured.heading"),
    subheading: t("automotive.dealerDirectory.featured.subheading"),
    trustNote: t("automotive.dealerDirectory.featured.trustNote"),
  };
}

export function getDealerDirectoryCardCopy(t) {
  return {
    profileCta: t("automotive.dealerDirectory.page.profileCta"),
    contactCta: t("automotive.dealerDirectory.card.contactCta"),
    featuredLabel: t("automotive.dealerDirectory.card.featuredLabel"),
    recentlyUpdatedLabel: t("automotive.dealerDirectory.card.recentlyUpdatedLabel"),
    displayNameFallback: t("automotive.dealerDirectory.card.displayNameFallback"),
    locationFallback: t("automotive.dealerDirectory.card.locationFallback"),
    badgesAria: t("automotive.dealerDirectory.card.badgesAria"),
    factsAria: t("automotive.dealerDirectory.card.factsAria"),
    priceRangeLabel: t("automotive.dealerDirectory.card.priceRangeLabel"),
    specialtyLabel: t("automotive.dealerDirectory.card.specialtyLabel"),
    logoAlt: (name) =>
      name
        ? t("automotive.dealerDirectory.card.logoAlt", { name })
        : t("automotive.dealerDirectory.card.logoAltFallback"),
  };
}

export function getDealerDirectoryCardInventoryLabel(t, item = {}) {
  const count = item.activeInventoryCount;
  if (count == null || Number.isNaN(Number(count))) {
    return t("automotive.dealerDirectory.card.inventoryUnknown");
  }
  const value = Number(count);
  if (value <= 0) return t("automotive.dealerDirectory.card.inventoryEmpty");
  if (value === 1) return t("automotive.dealerDirectory.card.inventoryOne");
  return t("automotive.dealerDirectory.card.inventoryMany", { count: value });
}

export function getDealerDirectoryCardContactLabel(t, item = {}) {
  const key = item.contactAvailability;
  if (!key) return null;
  const labelKey = `automotive.dealerDirectory.card.contact.${key}`;
  const translated = t(labelKey);
  return translated === labelKey ? null : translated;
}

export function getDealerDirectoryCardVerificationLabel(t, item = {}) {
  const status = item.verificationStatus || "unknown";
  const labelKey = `automotive.dealerDirectory.card.verification.${status}`;
  const translated = t(labelKey);
  return translated === labelKey
    ? t("automotive.dealerDirectory.card.verificationUnknown")
    : translated;
}

export function getDealerDirectoryTrustChecklistItems(t) {
  return [
    t("automotive.dealerDirectory.trustChecklist.availability"),
    t("automotive.dealerDirectory.trustChecklist.price"),
    t("automotive.dealerDirectory.trustChecklist.documents"),
    t("automotive.dealerDirectory.trustChecklist.inspection"),
    t("automotive.dealerDirectory.trustChecklist.payments"),
  ];
}

export function getDealerDirectoryBreadcrumbs(t, { homePath, searchPath, directoryPath }) {
  return [
    { label: t("automotive.dealerDirectory.breadcrumbHome"), href: homePath },
    { label: t("automotive.dealerDirectory.breadcrumbUsedCars"), href: searchPath },
    { label: t("automotive.dealerDirectory.label"), href: directoryPath },
  ];
}
